import { TableName } from '../../../tables'
import { firstItem } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { ProductPrices } from '../state/types'

export const useProductPricesLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllProductPrices = async (dbRequest = false) => {
            const { loadAll } = loaders(companyId)
            return loadAll(TableName.PRODUCT_PRICES, dbRequest) as Promise<ProductPrices[]>
        }

        const loadProductPrices = async (productId: string, dbRequest = false) => {
            const { loadFiltered } = loaders(companyId)
            const productPrices = await loadFiltered(TableName.PRODUCT_PRICES, dbRequest, { productId }) as ProductPrices[]
            return firstItem(productPrices)
        }

        const loadProductsPrices = async (productIds: string[], dbRequest = false) => {
            const { loadFilteredByList } = loaders(companyId)
            return loadFilteredByList(TableName.PRODUCT_PRICES, dbRequest, 'productId', productIds) as Promise<ProductPrices[]>
        }

        const countProductPrices = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.PRODUCT_PRICES, options)
        }

        return {
            loadAllProductPrices,
            loadProductPrices,
            loadProductsPrices,
            countProductPrices
        }
    }
}
